import { Inject, Injectable, Injector } from "@angular/core";
import { SocketMessagesService } from "../core/socket/socket.service";
import { catchError, tap } from "rxjs/operators";
import { EMPTY, Observable } from "rxjs";
import { CustomErrorHandlerService } from "./custom-error-handler.service";
import { NotificationsService } from "./notifications/notifications.service";

@Injectable()
export class UserService {
    injector: Injector;
    // @Inject(Injector) injector: Injector,
    // get messages() {
    //     return this.injector.get(SocketMessagesService)
    // }

    constructor(
        @Inject(Injector) injector: Injector,
        private notifications: NotificationsService,
        private errors: CustomErrorHandlerService
    ) {
        this.injector = injector;
    }

    get messages() {
        return this.injector.get(SocketMessagesService)
    }

    sendRestorePasswordRequest$(email: string): Observable<unknown> {
        return this.messages.request$("restorePassword", { email }).pipe(
            tap(() => {
                this.notifications.message(`Password recovery link was sent to ${email}.`);
            }),
            catchError((error) => {
                this.errors.handleError(error, '@user.service1');
                return EMPTY;
            })
        );
    }

    setNewPassword$(code: string, password: string): Observable<unknown> {
        return this.messages.request$("setNewRestorePassword", { code, password }).pipe(
            tap(() => {
                this.notifications.message(`Password was successfully changed`);
            }),
            catchError((error) => {
                this.errors.handleError(error, '@user.service2');
                return EMPTY;
            })
        );
    }
}
